import TermDrawer from "../TermDrawer";
import "./TopicsDrawer.scss";

const AddTopicsDrawer = () => <TermDrawer type="add-topic" />;

export default AddTopicsDrawer;
